import type { CSSProperties } from "react";
import {
  Zap,
  Timer,
  Clock,
  Infinity as InfinityIcon,
  type LucideProps,
} from "lucide-react";
import type { TcIconName } from "@chess/shared";

export type { TcIconName };

interface Props {
  name: TcIconName;
  size?: number;
  color?: string;
  style?: CSSProperties;
}

function Bullet({ size = 24, color = "currentColor", strokeWidth = 1.75, style }: { size?: number; color?: string; strokeWidth?: number; style?: CSSProperties }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ display: "block", ...style }}
      aria-hidden
    >
      {/* tip */}
      <path d="M8 9 C8 5, 10 2, 12 2 C14 2, 16 5, 16 9" />
      {/* casing */}
      <path d="M8 9 H16 V19 H8 Z" />
      {/* rim */}
      <path d="M7.5 19 H16.5 V22 H7.5 Z" />
    </svg>
  );
}

const LUCIDE: Partial<Record<TcIconName, (p: LucideProps) => JSX.Element>> = {
  blitz: Zap as unknown as (p: LucideProps) => JSX.Element,
  rapid: Timer as unknown as (p: LucideProps) => JSX.Element,
  classical: Clock as unknown as (p: LucideProps) => JSX.Element,
  endless: InfinityIcon as unknown as (p: LucideProps) => JSX.Element,
};

export function TcIcon({ name, size = 32, color = "currentColor", style }: Props) {
  if (name === "bullet") return <Bullet size={size} color={color} style={style} />;
  const Icon = LUCIDE[name]!;
  return (
    <Icon
      size={size}
      color={color}
      strokeWidth={1.75}
      style={{ display: "block", ...style }}
      aria-hidden
    />
  );
}
